<template>
  <div id="Introduction">
    <b-container>
      <div class="top">
        <div class="top__left">
          <h3>get more with your membership!</h3>
          <h2>Our City, Our Team</h2>
          <p>
            Your Pistons One Membership and our team are the foundation of the
            Detroit Pistons. Together, our passion, optimism and relentless
            determination drive Pistons Basketball forward and connect the
            people of our city. Together, we are building one of the greatest
            stories in basketball and driving impact on and off the court in
            Detroit.
          </p>
        </div>
        <div class="top__right">
          <img src="@/assets/images/intro/d-up-light.png" />
        </div>
      </div>
    </b-container>
    <b-container class="bottom-container">
      <div class="bottom">
        <div class="payment-plan">payment plan</div>
        <div class="bottom__right">
          Take advantage of our monthly interest free payment plan and watch the
          team fight for the 313. We Hustle Different. D-Up!
          <br /><br />
          You are opted-in to our 8-Month Payment Plan. This method of payment
          charges your existing credit card on file monthly, with the first
          payment being on April 1st. Subsequent monthly payments will be
          charged on the 1st of every month for the duration of the 8-month
          billing cycle.
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Introduction",
};
</script>

<style lang="scss" scoped>
#Introduction {
  background-image: url("~@/assets/images/intro/our-city-bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  padding-top: 151px;
  @media (min-width: 992px) {
    background-attachment: fixed;
  }
  @media (max-width: 992px) {
    padding-top: 50px;
  }
  .container {
    display: flex;
    flex-direction: column;
    &.bottom-container {
      @media (max-width: 776px) {
        max-width: 100vw;
        padding: 0;
      }
    }
  }
  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 121px;
    @media (max-width: 992px) {
      flex-direction: column;
      margin-bottom: 35px;
    }
    &__left {
      width: calc(100% - 580px);
      max-width: 515px;
      @media (max-width: 992px) {
        width: 100%;
        max-width: 100%;
      }
      h3 {
        font-family: Abolition;
        font-weight: normal;
        font-size: 32px;
        line-height: 35px;
        letter-spacing: normal;
        color: #de1e35;
        text-transform: uppercase;
        margin: 0;
        @media (max-width: 992px) {
          font-size: 28px;
          line-height: 33px;
        }
      }
      h2 {
        font-family: Birdrockers;
        font-weight: normal;
        font-size: 52px;
        line-height: 52px;
        letter-spacing: normal;
        color: #ffffff;
        margin: -6px 0 35px 0;
        @media (max-width: 992px) {
          font-size: 42px;
          line-height: 42px;
        }
      }
      p {
        font-family: DINPro;
        font-weight: normal;
        font-size: 18px;
        line-height: 28px;
        letter-spacing: normal;
        color: #ffffff;
        @media (max-width: 992px) {
          font-size: 14px;
          line-height: 24px;
        }
      }
    }
    &__right {
      width: 526px;
      @media (max-width: 992px) {
        width: 100%;
        max-width: 400px;
      }
      img {
        width: 100%;
        object-fit: contain;
      }
    }
  }
  .bottom {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background-image: url("~@/assets/images/intro/payment-plan-white-texture.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    padding: 20px 45px 20px 49px;
    @media (max-width: 992px) {
      flex-direction: column;
      align-items: flex-start;
      padding: 22px 25px 23px 20px;
    }
    .payment-plan {
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: Abolition;
      font-weight: normal;
      font-size: 70px;
      line-height: 70px;
      letter-spacing: normal;
      color: #000000;
      text-transform: uppercase;
      cursor: pointer;
      @media (max-width: 992px) {
        font-size: 50px;
        line-height: 50px;
        margin-bottom: 20px;
      }
    }
    &__right {
      width: calc(100% - 323px);
      max-width: 628px;
      font-family: DINPro;
      font-weight: normal;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: normal;
      color: #000a12;
      @media (max-width: 992px) {
        width: 100%;
      }
    }
  }
}
</style>